import { TranslationKeys } from "./en";

export const de: TranslationKeys = {
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    confirm: "Bestätigen",
    back: "Zurück",
    next: "Weiter",
    done: "Fertig",
    search: "Suchen",
    noResults: "Keine Ergebnisse gefunden",
    viewAll: "Alle anzeigen",
    seeMore: "Mehr anzeigen",
    close: "Schließen",
    retry: "Erneut versuchen",
    share: "Teilen",
    copy: "Kopieren",
    signOut: "Abmelden",
    or: "oder",
    and: "und",
    yes: "Ja",
    no: "Nein",
    optional: "Optional",
    required: "Erforderlich",
    submit: "Absenden",
    update: "Aktualisieren",
    create: "Erstellen",
    add: "Hinzufügen",
    remove: "Entfernen",
    filter: "Filtern",
    sort: "Sortieren",
    all: "Alle",
    none: "Keine",
    select: "Auswählen",
    selected: "ausgewählt",
    showing: "Zeige",
    of: "von",
    to: "bis",
    from: "von",
  },
  nav: {
    dashboard: "Übersicht",
    feed: "Feed",
    workout: "Training",
    templates: "Vorlagen",
    leaderboard: "Rangliste",
    analytics: "Statistiken",
    achievements: "Erfolge",
    premium: "Premium",
    friends: "Freunde",
    profile: "Profil",
    notifications: "Benachrichtigungen",
    settings: "Einstellungen",
    support: "Support",
    logout: "Abmelden",
    more: "Mehr",
    newWorkout: "Neues Training",
    home: "Startseite",
    admin: "Admin",
  },
  auth: {
    welcome: "Willkommen",
    signIn: "Anmelden",
    signUp: "Registrieren",
    signInDescription: "Melde dich bei deinem Konto an",
    signUpDescription: "Erstelle ein neues Konto, um loszulegen",
    signInOrCreateAccount: "Melde dich an oder erstelle ein Konto",
    email: "E-Mail",
    password: "Passwort",
    username: "Benutzername",
    usernamePlaceholder: "Wähle einen Benutzernamen",
    passwordPlaceholder: "Gib dein Passwort ein",
    forgotPassword: "Passwort vergessen?",
    resetPassword: "Passwort zurücksetzen",
    resetPasswordDesc: "Gib deine E-Mail ein, um einen Zurücksetz-Link zu erhalten",
    resetPasswordDescription: "Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.",
    sendResetLink: "Link senden",
    setNewPassword: "Neues Passwort festlegen",
    confirmPassword: "Passwort bestätigen",
    confirmNewPassword: "Neues Passwort bestätigen",
    confirmNewPasswordBtn: "Passwort bestätigen",
    confirmYourPassword: "Bestätige dein Passwort",
    newPassword: "Neues Passwort",
    enterNewPassword: "Neues Passwort eingeben",
    enterNewPasswordBelow: "Gib dein neues Passwort unten ein",
    createAccount: "Konto erstellen",
    alreadyHaveAccount: "Hast du bereits ein Konto?",
    dontHaveAccount: "Hast du noch kein Konto?",
    signingIn: "Anmelden...",
    creatingAccount: "Konto wird erstellt...",
    sending: "Senden...",
    updating: "Aktualisieren...",
    passwordRequirements: "Muss mindestens 12 Zeichen enthalten, einschließlich Großbuchstaben, Kleinbuchstaben, Zahl und Sonderzeichen",
    passwordHint: "Muss Großbuchstaben, Kleinbuchstaben, Zahl und Sonderzeichen enthalten",
    emailVerified: "E-Mail bestätigt!",
    emailVerifiedDesc: "Du kannst dich jetzt mit deinen Anmeldedaten anmelden",
    checkEmail: "Überprüfe deine E-Mail für den Bestätigungslink",
    checkYourEmail: "Überprüfe deine E-Mail",
    resetLinkSent: "Zurücksetz-Link gesendet",
    failedToSendReset: "Zurücksetz-Link konnte nicht gesendet werden",
    accountCreated: "Konto erstellt!",
    welcomeMessage: "Willkommen bei FITLINK! Lass uns loslegen.",
    welcomeToFitlink: "Willkommen bei FITLINK",
    loginFailed: "Anmeldung fehlgeschlagen",
    signupFailed: "Registrierung fehlgeschlagen",
    usernameTaken: "Dieser Benutzername ist bereits vergeben",
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    passwordsDontMatchDesc: "Bitte stelle sicher, dass beide Passwörter übereinstimmen",
    passwordUpdated: "Passwort aktualisiert!",
    passwordUpdatedDesc: "Dein Passwort wurde erfolgreich aktualisiert",
    passwordRequirementsNotMet: "Passwort erfüllt nicht die Anforderungen",
    missingCredentials: "Fehlende Anmeldedaten",
    enterEmail: "Bitte gib deine E-Mail-Adresse ein",
    enterPassword: "Bitte gib dein Passwort ein",
    accountLocked: "Konto gesperrt",
    tooManyAttempts: "Zu viele Versuche. Bitte versuche es später erneut.",
    tryAgainLater: "Bitte versuche es später erneut",
    serviceUnavailable: "Dienst nicht verfügbar",
    serviceUnavailableDesc: "Bitte versuche es in ein paar Minuten erneut",
    privacyNotice: "Datenschutzhinweis",
    privacyDescription: "Wir erfassen deine Trainingsdaten, um personalisierte Fitness-Empfehlungen zu geben.",
    dataCollection: "Daten, die wir erfassen",
    dataPrivacy: "Datenschutz",
    dataPrivacyDesc: "Deine Daten sind verschlüsselt und werden niemals an Dritte verkauft",
    agreeToTerms: "Mit der Registrierung stimmst du unseren zu",
    termsAndPrivacy: "Nutzungsbedingungen und Datenschutzrichtlinie",
    termsOfUse: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinie",
    stayFitStayLinked: "Bleib fit, bleib verbunden.",
    tagline: "Dein persönlicher Fitness-Begleiter",
    verificationEmailSent: "Wir haben dir eine Bestätigungs-E-Mail gesendet. Bitte überprüfe deinen Posteingang und klicke auf den Link, um dein Konto zu bestätigen.",
    fullName: "Vollständiger Name",
  },
  settings: {
    title: "Einstellungen",
    description: "Verwalte deine App-Einstellungen und Daten",
    appearance: "Erscheinungsbild",
    darkMode: "Dunkelmodus",
    lightMode: "Hellmodus",
    themeDescription: "Zwischen hellem und dunklem Design wechseln",
    language: "Sprache",
    languageDescription: "Wähle deine bevorzugte Sprache",
    saveReload: "Speichern & Neuladen",
    profileManagement: "Profilverwaltung",
    personalInfo: "Persönliche Informationen",
    personalInfoDescription: "Aktualisiere deine Daten für KI-Empfehlungen",
    editPersonalInfo: "Persönliche Daten bearbeiten",
    goalsExperience: "Ziele & Erfahrung",
    goalsDescription: "Aktualisiere deine Fitnessziele und Erfahrungsstufe",
    updateGoals: "Ziele aktualisieren",
    subscription: "Abonnement",
    manageSubscription: "Abonnement verwalten",
    updatePayment: "Zahlung aktualisieren oder Plan kündigen",
    legalPrivacy: "Rechtliches & Datenschutz",
    legalDescription: "Unsere Richtlinien und Bedingungen überprüfen",
    termsOfUse: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinie",
    dangerZone: "Gefahrenzone",
    dangerDescription: "Lösche dauerhaft alle Trainingsdaten, PRs, Erfolge und Statistiken",
    resetStatistics: "Alle Statistiken zurücksetzen",
    deleteAccount: "Konto löschen",
    resetConfirmTitle: "Alle Statistiken zurücksetzen?",
    resetConfirmDescription: "Diese Aktion kann nicht rückgängig gemacht werden. Dies wird dauerhaft löschen:",
    resetConfirmList: {
      workouts: "Deine gesamte Trainingshistorie",
      exercises: "Alle Übungsaufzeichnungen",
      prs: "Alle persönlichen Rekorde (PRs)",
      achievements: "Alle Erfolge und Abzeichen",
      streaks: "Alle Trainingsserien",
    },
    resetConfirmWarning: "Bist du dir absolut sicher, dass du fortfahren möchtest?",
    resetButton: "Ja, alles zurücksetzen",
    resetting: "Wird zurückgesetzt...",
    deleteConfirmTitle: "Konto dauerhaft löschen?",
    deleteWarning: "Diese Aktion ist DAUERHAFT und kann NICHT rückgängig gemacht werden!",
    deleteConfirmList: {
      workouts: "Alle Trainings und Übungshistorie",
      achievements: "Alle Erfolge und persönlichen Rekorde",
      friends: "Alle Freunde und sozialen Verbindungen",
      photos: "Alle Fotos und Check-in-Daten",
      profile: "Dein Profil und Kontoinformationen",
      subscription: "Dein Abonnement (falls aktiv)",
    },
    typeDelete: "Tippe DELETE zur Bestätigung:",
    deleting: "Wird gelöscht...",
    deleteButton: "Konto dauerhaft löschen",
  },
  toast: {
    saved: "Änderungen erfolgreich gespeichert",
    deleted: "Erfolgreich gelöscht",
    error: "Etwas ist schiefgelaufen",
    copied: "In Zwischenablage kopiert",
    signedOut: "Erfolgreich abgemeldet",
    workoutDeleted: "Training gelöscht",
    workoutSaved: "Training erfolgreich gespeichert",
    templateSaved: "Vorlage gespeichert!",
    templateDeleted: "Vorlage gelöscht",
    preferencesUpdated: "Einstellungen aktualisiert",
    friendRequestSent: "Freundschaftsanfrage gesendet",
    friendRequestAccepted: "Freundschaftsanfrage angenommen!",
    profileUpdated: "Profil erfolgreich aktualisiert",
  },
  workout: {
    title: "Training",
    startWorkout: "Training starten",
    finishWorkout: "Training beenden",
    saveWorkout: "Training speichern",
    addExercise: "Übung hinzufügen",
    sets: "Sätze",
    reps: "Wiederholungen",
    weight: "Gewicht",
    notes: "Notizen",
    rest: "Pause",
    noExercises: "Noch keine Übungen hinzugefügt",
    duration: "Dauer",
    calories: "Kalorien",
    description: "Beschreibung",
    private: "Privat",
    public: "Öffentlich",
    trackDuration: "Dauer verfolgen",
    manualDuration: "Manuelle Dauer",
    exercisePlaceholder: "Füge deine erste Übung hinzu, um zu beginnen",
    saveAsTemplate: "Als Vorlage speichern",
    loadTemplate: "Vorlage laden",
    doAgain: "Wiederholen",
    analyze: "KI-Analyse",
    deleteConfirm: "Training löschen?",
    deleteConfirmDescription: "Diese Aktion kann nicht rückgängig gemacht werden.",
    kg: "kg",
    lbs: "lbs",
    minutes: "Minuten",
    hours: "Stunden",
    seconds: "Sekunden",
    set: "Satz",
    exercise: "Übung",
    exercises: "Übungen",
    completed: "Abgeschlossen",
    inProgress: "In Bearbeitung",
    paused: "Pausiert",
    resume: "Fortsetzen",
    pause: "Pause",
    stop: "Stopp",
    restTimer: "Pausentimer",
    skipRest: "Pause überspringen",
    addSet: "Satz hinzufügen",
    removeSet: "Satz entfernen",
    superset: "Supersatz",
    createSuperset: "Supersatz erstellen",
    personalRecord: "Persönlicher Rekord",
    newPR: "Neuer PR!",
    previousBest: "Vorheriges Beste",
    selectExercise: "Übung auswählen",
    searchExercises: "Übungen suchen...",
    recentExercises: "Letzte Übungen",
    allExercises: "Alle Übungen",
    customExercise: "Eigene Übung",
    addCustomExercise: "Eigene Übung hinzufügen",
    targetMuscles: "Zielmuskeln",
    techniqueTips: "Techniktipps",
    commonMistakes: "Häufige Fehler",
    history: "Verlauf",
    noHistory: "Kein Verlauf verfügbar",
    tagFriends: "Freunde markieren",
    shareWorkout: "Training teilen",
    copyWorkout: "Training kopieren",
    workoutComplete: "Training abgeschlossen!",
    greatJob: "Gut gemacht!",
    summary: "Zusammenfassung",
    totalVolume: "Gesamtvolumen",
    totalSets: "Gesamte Sätze",
    totalReps: "Gesamte Wiederholungen",
  },
  dashboard: {
    title: "Übersicht",
    welcome: "Willkommen zurück",
    todayWorkout: "Heutiges Training",
    weeklyProgress: "Wöchentlicher Fortschritt",
    recentActivity: "Letzte Aktivität",
    quickActions: "Schnellaktionen",
    noWorkouts: "Noch keine Trainings",
    startFirst: "Starte dein erstes Training!",
    pullToRefresh: "Zum Aktualisieren ziehen",
    loadMore: "Mehr laden",
    communityFeed: "Community-Feed",
    yourFeed: "Dein Feed",
    announcements: "Ankündigungen",
    noActivity: "Keine aktuelle Aktivität",
    startWorking: "Beginne mit dem Training, um deinen Fortschritt hier zu sehen!",
    streak: "Serie",
    days: "Tage",
    thisWeek: "Diese Woche",
    personalRecords: "Persönliche Rekorde",
    weeklyGoal: "Wochenziel",
    workoutsThisWeek: "Trainings diese Woche",
    activity: "Aktivität",
    upgradeToPremium: "Auf Premium upgraden",
    unlockFeatures: "Statistiken, Rangliste & Analyse freischalten",
    beFirstToLog: "Sei der Erste, der ein Training loggt und mit der Community teilt!",
    logFirstWorkout: "Erstes Training loggen",
    doLiveWorkout: "Live-Training starten",
    editWorkout: "Training bearbeiten",
    moreExercises: "mehr",
    showLess: "Weniger anzeigen",
    aiWorkoutAnalysis: "KI-Trainingsanalyse",
    aiAnalysisDescription: "Erhalte KI-gestützte Einblicke zu Leistung, Formtipps und Verbesserungsvorschlägen. Premium-Funktion.",
    loadingMore: "Lade weitere Trainings...",
    endOfFeed: "Du hast das Ende des Feeds erreicht",
    workoutTitle: "Trainingstitel",
    workoutTitlePlaceholder: "Mein großartiges Training",
    descriptionPlaceholder: "Beschreibe dein Training...",
    saveChanges: "Änderungen speichern",
    withFriends: "mit Freunden",
  },
  profile: {
    title: "Profil",
    editProfile: "Profil bearbeiten",
    followers: "Follower",
    following: "Folgt",
    workouts: "Trainings",
    joined: "Beigetreten",
    yourGoals: "Deine Ziele",
    fitnessGoal: "Fitnessziel",
    experienceLevel: "Erfahrungsstufe",
    weeklyCheckIn: "Wöchentlicher Check-in",
    workoutHistory: "Trainingshistorie",
    checkIns: "Check-ins",
    upgradePremium: "Auf Premium upgraden",
    unlockFeatures: "Statistiken, Rangliste & Analyse freischalten",
    viewPlans: "Pläne anzeigen",
    bio: "Bio",
    fullName: "Vollständiger Name",
    dateOfBirth: "Geburtsdatum",
    height: "Größe",
    currentWeight: "Aktuelles Gewicht",
    gender: "Geschlecht",
    male: "Männlich",
    female: "Weiblich",
    other: "Andere",
    preferNotToSay: "Keine Angabe",
    saveChanges: "Änderungen speichern",
    noGoalsSet: "Noch keine Ziele gesetzt",
    setGoals: "Setze deine Fitnessziele",
    memberSince: "Mitglied seit",
    totalWorkouts: "Gesamte Trainings",
    currentStreak: "Aktuelle Serie",
    longestStreak: "Längste Serie",
    verified: "Verifiziert",
    statisticsReset: "Statistiken zurückgesetzt",
    statisticsResetDesc: "Alle deine Statistiken wurden erfolgreich zurückgesetzt",
    resetFailed: "Zurücksetzen fehlgeschlagen",
    goalsUpdated: "Ziele aktualisiert",
    goalsUpdatedDesc: "Deine Fitnessziele wurden aktualisiert",
    goals: {
      buildMuscle: "Muskeln aufbauen",
      loseWeight: "Gewicht verlieren",
      getStronger: "Stärker werden",
      improveEndurance: "Ausdauer verbessern",
      stayActive: "Aktiv bleiben",
      athleticPerformance: "Sportliche Leistung",
    },
  },
  achievements: {
    title: "Erfolge",
    unlocked: "Freigeschaltet",
    locked: "Gesperrt",
    progress: "Fortschritt",
    keepGoing: "Weiter so!",
    newUnlock: "Neuer Erfolg freigeschaltet!",
    milestone: "Meilenstein",
    strength: "Stärke",
    consistency: "Beständigkeit",
    social: "Sozial",
    variety: "Vielfalt",
    volume: "Volumen",
    all: "Alle",
    earned: "Verdient",
    unearned: "Noch nicht verdient",
    congratulations: "Herzlichen Glückwunsch!",
    youEarned: "Du hast verdient",
    shareAchievement: "Erfolg teilen",
    viewAll: "Alle Erfolge anzeigen",
    recentlyUnlocked: "Kürzlich freigeschaltet",
  },
  friends: {
    title: "Freunde",
    addFriend: "Freund hinzufügen",
    searchUsers: "Benutzer suchen...",
    pending: "Ausstehend",
    accepted: "Freunde",
    noFriends: "Noch keine Freunde",
    sendRequest: "Anfrage senden",
    acceptRequest: "Annehmen",
    declineRequest: "Ablehnen",
    removeFriend: "Freund entfernen",
    friendRequests: "Freundschaftsanfragen",
    myFriends: "Meine Freunde",
    suggestions: "Vorschläge",
    noRequests: "Keine ausstehenden Anfragen",
    requestSent: "Anfrage gesendet!",
    requestAccepted: "Anfrage angenommen!",
    requestDeclined: "Anfrage abgelehnt",
    friendRemoved: "Freund entfernt",
    mutualFriends: "gemeinsame Freunde",
    viewProfile: "Profil anzeigen",
    message: "Nachricht",
  },
  premium: {
    title: "Premium",
    upgrade: "Upgraden",
    features: "Premium-Funktionen",
    monthly: "Monatlich",
    yearly: "Jährlich",
    currentPlan: "Aktueller Plan",
    subscribe: "Abonnieren",
    restore: "Käufe wiederherstellen",
    perMonth: "/Monat",
    perYear: "/Jahr",
    savePercent: "Spare",
    mostPopular: "Am beliebtesten",
    freePlan: "Kostenloser Plan",
    premiumPlan: "Premium-Plan",
    includesFeatures: "Enthält alle Funktionen",
    unlockAll: "Alle Funktionen freischalten",
    alreadyPremium: "Du bist bereits Premium-Mitglied!",
    manageSubscription: "Abonnement verwalten",
    cancelAnytime: "Jederzeit kündbar",
    startFreeTrial: "Kostenlose Testversion starten",
    trialDays: "Tage kostenlose Testversion",
    bestValue: "Bester Wert",
    billedAnnually: "Jährlich abgerechnet",
    billedMonthly: "Monatlich abgerechnet",
    featuresList: {
      analytics: "Erweiterte Statistiken & Einblicke",
      leaderboard: "Zugang zur Fitness-Rangliste",
      aiAnalysis: "KI-Trainingsanalyse",
      templates: "Unbegrenzte Vorlagen",
      checkIns: "Wöchentliche Check-ins mit Fotos",
      exportData: "Deine Daten exportieren",
      prioritySupport: "Prioritäts-Support",
      noAds: "Werbefreies Erlebnis",
    },
  },
  templates: {
    title: "Vorlagen",
    create: "Vorlage erstellen",
    edit: "Vorlage bearbeiten",
    delete: "Vorlage löschen",
    myTemplates: "Meine Vorlagen",
    publicTemplates: "Öffentliche Vorlagen",
    noTemplates: "Noch keine Vorlagen",
    createFirst: "Erstelle deine erste Vorlage",
    templateName: "Vorlagenname",
    templateDescription: "Beschreibung",
    category: "Kategorie",
    makePublic: "Öffentlich machen",
    publicDescription: "Erlaube anderen Premium-Benutzern, diese Vorlage zu sehen und zu nutzen",
    addExercise: "Übung hinzufügen",
    saveTemplate: "Vorlage speichern",
    useTemplate: "Vorlage verwenden",
    startWorkout: "Training starten",
    exercises: "Übungen",
    createdBy: "Erstellt von",
    generateWithAI: "Mit KI generieren",
    aiPromptPlaceholder: "Beschreibe das gewünschte Training (z.B. 'Oberkörper-Krafttraining für Anfänger')...",
    generating: "Generiere...",
    categories: {
      all: "Alle",
      beginner: "Anfänger",
      advanced: "Fortgeschritten",
      strength: "Kraft",
      hypertrophy: "Hypertrophie",
      endurance: "Ausdauer",
      general: "Allgemein",
    },
  },
  analytics: {
    title: "Statistiken",
    overview: "Übersicht",
    volume: "Volumen",
    strength: "Stärke",
    progression: "Progression",
    calendar: "Kalender",
    period: "Zeitraum",
    week: "Woche",
    month: "Monat",
    year: "Jahr",
    totalWorkouts: "Gesamte Trainings",
    totalVolume: "Gesamtvolumen",
    avgVolume: "Durchschn. Volumen",
    personalRecords: "Persönliche Rekorde",
    muscleGroups: "Muskelgruppen",
    volumeOverTime: "Volumen über Zeit",
    strengthProgress: "Stärkefortschritt",
    workoutCalendar: "Trainingskalender",
    noData: "Keine Daten verfügbar",
    startTracking: "Beginne deine Trainings zu tracken, um Statistiken zu sehen",
    comparedToPrevious: "verglichen mit vorherigem Zeitraum",
    improvement: "Verbesserung",
    decline: "Rückgang",
    noChange: "keine Änderung",
    exerciseTrends: "Übungstrends",
    plateauDetection: "Plateau-Erkennung",
    injuryRisk: "Verletzungsrisiko-Bewertung",
    fitnessScore: "Fitness-Score",
    restDays: "Ruhetage",
    prRate: "PR-Rate",
    bestDay: "Bester Tag",
    volumeVelocity: "Volumen-Geschwindigkeit",
    filters: {
      muscleGroup: "Muskelgruppe",
      exerciseType: "Übungstyp",
      all: "Alle",
      chest: "Brust",
      back: "Rücken",
      legs: "Beine",
      shoulders: "Schultern",
      arms: "Arme",
      cardio: "Cardio",
      strength: "Kraft",
    },
  },
  notifications: {
    title: "Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
    deleteAll: "Alle löschen",
    noNotifications: "Noch keine Benachrichtigungen",
    preferences: "Benachrichtigungseinstellungen",
    types: {
      like: "Like",
      comment: "Kommentar",
      friendRequest: "Freundschaftsanfrage",
      friendAccepted: "Freund akzeptiert",
      personalRecord: "Persönlicher Rekord",
      workoutTag: "Training-Tag",
      announcement: "Ankündigung",
    },
    settings: {
      likes: "Likes",
      likesDescription: "Wenn jemand dein Training liked",
      comments: "Kommentare",
      commentsDescription: "Wenn jemand dein Training kommentiert",
      friendRequests: "Freundschaftsanfragen",
      friendRequestsDescription: "Wenn jemand dir eine Freundschaftsanfrage sendet",
      friendAccepted: "Freund akzeptiert",
      friendAcceptedDescription: "Wenn jemand deine Freundschaftsanfrage annimmt",
      personalRecords: "Persönliche Rekorde",
      personalRecordsDescription: "Wenn du einen neuen persönlichen Rekord erreichst",
      workoutTags: "Training-Tags",
      workoutTagsDescription: "Wenn jemand dich in einem Training markiert",
    },
    deleteAllConfirm: "Alle Benachrichtigungen löschen?",
    deleteAllDescription: "Dies wird alle Benachrichtigungen dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden.",
    allMarkedRead: "Alle Benachrichtigungen als gelesen markiert",
    allDeleted: "Alle Benachrichtigungen gelöscht",
  },
  support: {
    title: "Support-Center",
    contactUs: "Kontaktiere uns",
    contactDescription: "Brauchst du Hilfe? Unser Support-Team ist für dich da.",
    emailSupport: "E-Mail-Support",
    responseTime: "Wir antworten in der Regel innerhalb von 24 Stunden",
    submitTicket: "Support-Ticket einreichen",
    faq: "FAQ",
    frequentlyAsked: "Häufig gestellte Fragen",
    privacyPolicy: "Datenschutzrichtlinie",
    privacyDescription: "Erfahre, wie wir deine Daten schützen und verarbeiten",
    accountDeletion: "Kontolöschung",
    accountDeletionDescription: "Anleitung zum dauerhaften Löschen deines Kontos",
    goToSettings: "Zu den Einstellungen",
    faqs: {
      cancelSubscription: {
        question: "Wie kündige ich mein Abonnement?",
        answer: "Du kannst dein Abonnement über deine Kontoeinstellungen verwalten. Für Web-Abonnements nutze das Kundenportal. Für iOS-Abonnements gehe zu Einstellungen > [Dein Name] > Abonnements auf deinem iPhone.",
      },
      deleteAccount: {
        question: "Wie lösche ich mein Konto?",
        answer: "Du kannst dein Konto über den Einstellungen-Dialog in der App löschen. Dies wird alle deine Daten dauerhaft löschen, einschließlich Trainings, Fortschrittsfotos und persönliche Rekorde.",
      },
      dataAfterDeletion: {
        question: "Was passiert mit meinen Daten nach der Kontolöschung?",
        answer: "Alle deine Daten werden dauerhaft von unseren Servern gelöscht, einschließlich Trainings, Fotos, Erfolge und persönliche Informationen. Diese Aktion kann nicht rückgängig gemacht werden.",
      },
      restorePurchase: {
        question: "Wie stelle ich meinen Apple In-App-Kauf wieder her?",
        answer: "Gehe zur Premium-Seite in der App und tippe auf die Schaltfläche 'Käufe wiederherstellen'. Stelle sicher, dass du mit derselben Apple-ID angemeldet bist, die für den ursprünglichen Kauf verwendet wurde.",
      },
      exportData: {
        question: "Kann ich meine Trainingsdaten exportieren?",
        answer: "Premium-Benutzer können ihre Trainingshistorie von der Statistik-Seite exportieren. Kostenlose Benutzer können den Support für Datenexport-Anfragen kontaktieren.",
      },
    },
  },
  leaderboard: {
    title: "Rangliste",
    rank: "Rang",
    user: "Benutzer",
    score: "Punktzahl",
    fitnessScore: "Fitness-Score",
    weeklyVolume: "Wöchentliches Volumen",
    monthlyWorkouts: "Monatliche Trainings",
    totalPRs: "Gesamte PRs",
    yourRank: "Dein Rang",
    top10: "Top 10",
    friends: "Freunde",
    friendsRanking: "Freunde-Rangliste",
    global: "Global",
    globalRanking: "Globale Rangliste",
    noData: "Keine Ranglisten-Daten verfügbar",
    period: "Zeitraum",
    metric: "Metrik",
  },
  time: {
    justNow: "Gerade eben",
    minutesAgo: "m her",
    hoursAgo: "h her",
    daysAgo: "T her",
    weeksAgo: "W her",
    monthsAgo: "M her",
    yearsAgo: "J her",
    today: "Heute",
    yesterday: "Gestern",
    thisWeek: "Diese Woche",
    lastWeek: "Letzte Woche",
    thisMonth: "Diesen Monat",
    lastMonth: "Letzten Monat",
  },
  errors: {
    somethingWentWrong: "Etwas ist schiefgelaufen",
    tryAgain: "Bitte versuche es erneut",
    networkError: "Netzwerkfehler. Bitte überprüfe deine Verbindung.",
    notFound: "Nicht gefunden",
    unauthorized: "Du bist nicht berechtigt, diese Aktion auszuführen",
    forbidden: "Zugriff verboten",
    serverError: "Serverfehler. Bitte versuche es später erneut.",
    validationError: "Validierungsfehler",
    requiredField: "Dieses Feld ist erforderlich",
    invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein",
    invalidPassword: "Passwort erfüllt nicht die Anforderungen",
    passwordTooShort: "Passwort muss mindestens 12 Zeichen lang sein",
    usernameTaken: "Dieser Benutzername ist bereits vergeben",
    emailTaken: "Diese E-Mail ist bereits registriert",
    invalidCredentials: "Ungültige E-Mail oder Passwort",
    sessionExpired: "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
    rateLimited: "Zu viele Versuche. Bitte versuche es später erneut.",
    serviceUnavailable: "Dienst vorübergehend nicht verfügbar. Bitte versuche es in einem Moment erneut.",
  },
  landing: {
    hero: "Verfolge deine Fitnessreise",
    tagline: "Der ultimative Trainingsbegleiter zum Verfolgen von Fortschritten, Verbinden mit Freunden und Erreichen deiner Fitnessziele.",
    getStarted: "Loslegen",
    learnMore: "Mehr erfahren",
    features: {
      trackProgress: {
        title: "Fortschritt verfolgen",
        description: "Trainings protokollieren, persönliche Rekorde verfolgen und deine Verbesserung über die Zeit visualisieren.",
      },
      socialFeed: {
        title: "Sozialer Feed",
        description: "Erfolge teilen, Freunde anfeuern und gemeinsam motiviert bleiben.",
      },
      achieveGoals: {
        title: "Ziele erreichen",
        description: "Fitnessziele setzen, Erfolge freischalten und jeden Meilenstein feiern.",
      },
    },
  },
};
